import React from "react";
import styles from "./AdminSettings.module.scss";
import AdminAside from "../../components/AdminAside/AdminAside";
import AdminHeader from "../../components/AdminHeader/AdminHeader";
import Main from "./Components/Main/Main";

const AdminSettings = ({
  openModal,
  role,
  setIsOpenModal,
  referalValue,
  currentLang,
  setCurrentLang,
}) => {
  return (
    <div className={styles.wrapper}>
      <AdminAside setIsOpenModal={setIsOpenModal} isOpenModal={openModal}  role={role} />
      <div className={styles.container}>
        <AdminHeader
          openModal={openModal}
          setIsOpenModal={setIsOpenModal}
          referalValue={referalValue}
          currentLang={currentLang}
          setCurrentLang={setCurrentLang}
          role={role}
        />
        <Main />
      </div>
    </div>
  );
};

export default AdminSettings;
